module.exports = __webpack_public_path__ + "static/img/products discription_pool3.85667911.jpg";